import axios from "axios";
import { BASE_URL } from "../../../Helper/Helper";

const EnquiryState = {
  addEnquiry: async (requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/client/create-enquiry`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data.data;
    return datas;
  },

  getEnquiry: async () => {
    // FETCH API CALL For all notes
    const response = await axios.get(`${BASE_URL}/api/v2/client/get-enquiry`, {
      headers: {
        token: localStorage.getItem("token"),
      },
    });

    //console.log("response", response);
    let datas = response.data.data;
    //console.log("datas", datas);
    return datas;
  },

  deleteEnquiry: async (id) => {
    // FETCH API CALL For all notes
    const response = await axios.delete(
      `${BASE_URL}/api/v2/client/delete-enquiry/${id}`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data.data;
    // console.log("datas", datas);
    return datas;
  },

  updateEnquiry: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    await axios.put(
      `${BASE_URL}/api/v2/client/update-enquiry/${id}`,
      requestOptions
    );
  },
};

export default EnquiryState;
